import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const GameJump = Memo(({ animate }) => {
	const rootRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const hlRef = useRef(null);
	const hrRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const hlEl = hlRef.current;
			const hrEl = hrRef.current;
			if (!hlEl || !hrEl) return;

			const hlB = hlEl.getBBox();
			const hrB = hrEl.getBBox();
			const armY = 0.42;
			const hlOrigin = `${hlB.x + hlB.width} ${hlB.y + hlB.height * armY}`;
			const hrOrigin = `${hrB.x} ${hrB.y + hrB.height * armY}`;

			const tl = gsap.timeline({ paused: true });

			tl.to(rootRef.current, { duration: 0.2, y: -20 })
				.to(flRef.current, { duration: 0.2, svgOrigin: '66 183', rotation: 30 }, 0)
				.to(frRef.current, { duration: 0.2, svgOrigin: '124 183', rotation: -30 }, 0)
				.to(hlRef.current, { duration: 0.2, svgOrigin: hlOrigin, rotation: 24 }, 0)
				.to(hrRef.current, { duration: 0.2, svgOrigin: hrOrigin, rotation: -24 }, 0)
				.to(rootRef.current, { duration: 0.2, y: 0 }, 0.2)
				.to(flRef.current, { duration: 0.2, svgOrigin: '66 183', rotation: 0 }, 0.2)
				.to(frRef.current, { duration: 0.2, svgOrigin: '124 183', rotation: 0 }, 0.2)
				.to(hlRef.current, { duration: 0.2, svgOrigin: hlOrigin, rotation: 0 }, 0.2)
				.to(hrRef.current, { duration: 0.2, svgOrigin: hrOrigin, rotation: 0 }, 0.2);

			animRef.current = tl;
		}, rootRef);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			ref={rootRef}
			className={`svg-max gameJump`}
			viewBox='0 0 183.61 228.18'>
			<path
				ref={hlRef}
				className={`gameJump-hl defaultStyle`}
				d='M31.64,101.85c-2.19.19-6.04.8-9.62,3.32-18.31,12.92-4.24,58.2-16.37,62.51-.69.25-1.97.54-3.9,0'
			/>
			<path
				ref={hrRef}
				className={`gameJump-hr defaultStyle`}
				d='M150.86,105.29c2.19.19,6.04.8,9.62,3.32,18.31,12.92,4.24,58.2,16.37,62.51.69.25,1.97.54,3.9,0'
			/>
			<path
				ref={frRef}
				className={`gameJump-fr defaultStyle`}
				d='M112.5,183.6c.38,4.16,1.2,26.56,1.8,33.73.31,3.72,2.87,6.87,6.45,7.94,1.31.39,2.62.78,3.93,1.17'
			/>
			<path
				ref={flRef}
				className={`gameJump-fl defaultStyle`}
				d='M76.76,183.6c-.38,4.16-1.2,26.56-1.8,33.73-.31,3.72-2.87,6.87-6.45,7.94-1.31.39-2.62.78-3.93,1.17'
			/>
			<path d='M31.2,183.6h117.13L183.61,11.13,5.65,0c8.52,61.2,17.03,122.4,25.55,183.6Z' />
		</svg>
	);
});

export default GameJump;
